import { useViewFeaturesStore } from '@/store/viewFeaturesStore';
import { useThreeSceneStore } from '@/store/threeSceneStore';
import { saveLandmarksToStorage, savePaintedAreasToStorage } from '@/utils/viewFeatures';
import * as THREE from 'three';

/**
 * Initialize auto-save for view features
 * Call this once when the app starts
 * @param sceneRef Reference to the THREE.Scene for accessing building paths
 */
export const initializeViewFeaturesPersistence = (sceneRef: React.MutableRefObject<THREE.Scene | null>) => {
	// Track previous values to detect changes
	let previousLandmarks = useViewFeaturesStore.getState().landmarks;
	let previousPaintedAreas = useViewFeaturesStore.getState().paintedAreas;

	// Subscribe to store changes and auto-save
	useViewFeaturesStore.subscribe((state) => {
		// Check if events are paused (during load/clear operations)
		const areEventsPaused = useThreeSceneStore.getState().areEventsPaused;
		if (areEventsPaused) {
			// Update tracking variables but don't save
			previousLandmarks = state.landmarks;
			previousPaintedAreas = state.paintedAreas;
			return;
		}
		
		// Check if landmarks changed
		if (state.landmarks !== previousLandmarks) {
			previousLandmarks = state.landmarks;
			const scene = sceneRef.current;
			saveLandmarksToStorage(scene || undefined).catch(err => 
				console.error('Failed to auto-save landmarks:', err)
			);
		}

		// Check if painted areas changed
		if (state.paintedAreas !== previousPaintedAreas) {
			previousPaintedAreas = state.paintedAreas;
			savePaintedAreasToStorage().catch(err => 
				console.error('Failed to auto-save painted areas:', err)
			);
		}
	});
};
